import { Autocomplete, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  AutocompleteProps,
  JunctionStatusOptionsTypes,
  TicketStatusOptionsTypes,
} from "../../../../../../../utils/types";
import {
  FormAutocomplete,
  formClasses,
  labelClasses,
  LabeledAutocomplete,
} from "../../../../../../../styles/AutocompleteStyles";
import { junctionStatusOptions } from "../../../../../../../utils/constants";
import { optionsType } from "../../../../../../../utils/formTypes";
import { JunctionStatus } from "../../../../../../../utils/Enum.types";
interface JunctionStatusAutocompleteProps extends AutocompleteProps {
  onChange: (newValue: JunctionStatusOptionsTypes) => void;
  value: JunctionStatus | null;
}
const JunctionStatusAutocomplete = ({
  onKeyDown,
  value,
  onChange,
  label,
  autoFocus,
  placeholder,
}: JunctionStatusAutocompleteProps) => {
  const [autoValue, setAutoValue] = useState<optionsType | null>(null);

  let commonAutocompleteClassName = label
    ? labelClasses.inputRoot
    : formClasses.inputRoot;
  let commonTextFieldClassName = label
    ? labelClasses.formControlRoot
    : formClasses.formControlRoot;

  const Autocomplete = label ? LabeledAutocomplete : FormAutocomplete;

  useEffect(() => {
    if (value) {
      const foundValue = junctionStatusOptions.find(
        ({ value: optionsValue }) => optionsValue === value
      );

      setAutoValue(foundValue ? foundValue : null);
    } else {
      setAutoValue(null);
    }
  }, [value, junctionStatusOptions]);
  return (
    <Autocomplete
      className={commonAutocompleteClassName}
      options={junctionStatusOptions}
      onKeyDown={onKeyDown}
      value={autoValue}
      openOnFocus
      forcePopupIcon
      getOptionLabel={(option) => (option as JunctionStatusOptionsTypes).label}
      onChange={(e, newValue) => {
        onChange(newValue as JunctionStatusOptionsTypes);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          label={label}
          autoFocus={autoFocus}
          className={commonTextFieldClassName}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          placeholder={placeholder}
        />
      )}
    />
  );
};

export default JunctionStatusAutocomplete;
